import { render, staticRenderFns } from "./RaceHeader.vue?vue&type=template&id=ed8ccf02&scoped=true&"
import script from "./RaceHeader.vue?vue&type=script&lang=js&"
export * from "./RaceHeader.vue?vue&type=script&lang=js&"
import style0 from "./RaceHeader.vue?vue&type=style&index=0&id=ed8ccf02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8ccf02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VCard,VChip,VIcon})
